import * as React from "react";
import { makeStyles, Title3, Body1, tokens } from "@fluentui/react-components";
import { ErrorCircleRegular } from "@fluentui/react-icons";

export interface ErrorPanelProps {
  title?: string;
  message: string;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    textAlign: "center",
  },
  center: {
    textAlign: "center"
  },
  icon: {
    fontSize: "48px",
    color: tokens.colorPaletteRedForeground1,
  },
});

const ErrorPanel: React.FC<ErrorPanelProps> = ({ title, message }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <ErrorCircleRegular className={styles.icon} />
      {title && <Title3>{title}</Title3>}
      <Body1 className={styles.center}>{message}</Body1>
    </div>
  );
};

export default ErrorPanel;
